import type { SlideProps } from "@/engine/app/offsite-config";

export function Slide09KISortieren(_: SlideProps) {
  return (
    <div className="deck-root dark" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">KI im Kundenservice</div>
        <h1 className="deck-title rise rise-2">
          Intelligentes <br />
          <span className="accent">Sortieren</span>
        </h1>
        <p className="deck-sub rise rise-3">
          Heute macht ihr das manuell. Die KI macht das automatisch.
        </p>
      </header>

      <div className="ki-sort-flow">
        <div className="col-card rise rise-4 ki-sort-step">
          <div className="num">01</div>
          <h4>Kunde schreibt 2 Anliegen</h4>
        </div>

        <div className="ki-sort-quote rise rise-5">
          <div className="ki-sort-quote-from">Klaus Stromberg schreibt:</div>
          <div className="ki-sort-quote-text">
            „Ich möchte gerne meine IBAN ändern auf <strong>DE89 7894 5678 9012 3456 78</strong> und
            den Abschlag auf <strong>64&nbsp;€</strong> setzen."
          </div>
          <div className="ki-sort-quote-tags">
            <span className="ki-sort-tag">IBAN-Wechsel</span>
            <span className="ki-sort-tag">Abschlag 64 €</span>
          </div>
        </div>

        <div className="ki-sort-row">
          <div className="col-card rise rise-5 ki-sort-step">
            <div className="num">02</div>
            <h4>KI erstellt 2 Tickets</h4>
          </div>
          <div className="col-card rise rise-6 ki-sort-step">
            <div className="num">03</div>
            <h4>Routet an die richtigen Teams – oder direkt in die automatische Verarbeitung.</h4>
          </div>
        </div>
      </div>
    </div>
  );
}
